import React, { Component } from "react";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import BannerImg from "../../assets/images/banner/act-advantage.png";
import { Helmet } from "react-helmet";

class Advantage extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Why Enterprises Choose Avani Cimcon | Engineering Maturity & Modernization Advantage</title>
          <meta
            name="keywords"
            content="enterprise advantage, engineering maturity, legacy modernization, product development, offshore software development, relationship management, quality assurance, enterprise architecture, long-term partnerships"
          />
          <meta
            name="description"
            content="Avani Cimcon's advantage comes from engineering maturity, legacy modernization depth, product thinking, and long-term enterprise delivery experience."
          />
          <link rel="canonical" href="https://www.avanicimcon.com/advantage" />
        </Helmet>
        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">ACT Advantage</h1>
            <h5>Why long-term engineering maturity changes the outcome</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <p>
                Avani Cimcon's difference is not a slogan. It is the combination of engineering
                maturity, delivery discipline, and the ability to work inside existing enterprise
                environments rather than asking customers to throw them away.
              </p>
              <p>
                That matters because many modernization programs fail when they are treated as a
                technology replacement exercise. Avani Cimcon approaches them as architecture,
                migration, workflow, and partnership problems that need to be solved together.
              </p>

              <div className="shadow-sm p-3 mt-2">
                <h4 className="text-primary mb-3 font-weight-bold">Why the advantage is different</h4>

                <p>
                  The company's advantage comes from how it works: it combines design, engineering,
                  documentation, DBA support, testing, systems thinking, and governance around a
                  single delivery objective. That gives enterprise buyers a more complete path to
                  modernization.
                </p>

                <ul>
                  <li className="mb-3">
                    Broad support across design, documentation, DBA, systems, and QA services
                  </li>
                  <li className="mb-3">
                    An internal consultants group that advises project teams on technology and
                    process choices
                  </li>
                  <li className="mb-3">
                    Development frameworks and libraries that reduce maintenance cost and delivery
                    risk
                  </li>
                  <li>
                    Collaboration tools and utilities that support rapid application development and
                    relationship management
                  </li>
                </ul>
              </div>

              <div className="shadow-sm p-3 mt-4">
                <h4 className="text-primary mb-3 font-weight-bold">What enterprise buyers get</h4>

                <p>
                  Buyers get a partner that can modernize without discarding what already works.
                  That includes legacy platform knowledge, product engineering perspective, and the
                  patience required for long-term enterprise relationships.
                </p>

                <ul>
                  <li className="mb-3">
                    A sustainable delivery model shaped by continuous improvement in systems,
                    process, and people
                  </li>
                  <li className="mb-3">
                    Experienced resources with proven offshore and international delivery capability
                  </li>
                  <li className="mb-3">
                    Quality assurance practices adapted for enterprise software and modernization
                    programs
                  </li>
                  <li className="mb-3">
                    Planning, reporting, and documentation that make delivery visible
                  </li>
                  <li>
                    Relationship management experience built through worldwide client interactions
                  </li>
                </ul>
                <p className="mb-0">
                  That is why the advantage story connects naturally to{" "}
                  <Link to="/about">company history</Link>,{" "}
                  <Link to="/expertise-experience">delivery breadth</Link>, and{" "}
                  <Link to="/value-proposition">enterprise value proposition</Link>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Advantage;
